import styled from "styled-components";

export const InputDialogWrapper = styled.div`
  position: fixed;
  max-width: 484px;
  width: calc(100% - 40px);
  box-sizing: border-box;
  top: 40%;
  left: 50%;
  padding: 53px 15px 24px 15px;
  transform: translate(-50%, -50%);
  z-index: 1111;
  border-radius: 12px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  > .title {
    color: var(--Black-500, #202020);
    text-align: center;
    font-family: Pretendard;
    font-size: 25px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 35px */
  }

  > .input-box {
    margin-top: 20px;
    margin-bottom: 47px;
    width: calc(100% - 20px);
    justify-content: center;
    align-items: center;
    display: flex;
    background: #fff;
    color: #121212;
    text-align: center;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.165px;

    > input {
      padding: 15px 10px;
      width: 100%;
      height: 100%;
      border-radius: 8px;
      border: 1px solid var(--Black-200, #b7b7b7);
      outline: none;
      text-align: center;
    }
  }

  > .button-wrapper {
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 8px;

    > .cancel-button {
      padding: 15px 0;
      display: flex;
      width: 135px;
      justify-content: center;
      align-items: center;
      color: var(--Purple-300, #6436e7);
      text-align: center;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: -0.165px;
      cursor: pointer;
    }

    > .create-button {
      cursor: pointer;
      display: flex;
      width: 341px;
      padding: 15px 0;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 8px;
      background: #d91818;
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: -0.165px;
    }
  }
`;

export const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1100;
  width: 100%;
  height: 100vh;
  opacity: 0.3;
  background: var(--kakao-logo, #000);
`;
